import fetch from '@/util/fetch';
import {baseUrl2} from '@/global';

export const getWisdomPlatformQrcode = (data) => fetch.post(`${baseUrl2}/yunba/base/qrcode/getWisdomPlatformQrcode`, data, {isIgnoreToken: true});
